var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrifoodLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32.000000pt",
    height: "32.000000pt",
    viewBox: "0 0 32.000000 32.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,32.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 270 c-12 -12 -20 -29 -18 -38 3 -9 -8 -36 -24 -59 -28 -42 -35 -63 -20 -63 5 0 17 18 27 41 10 22 31 49 47 60 17 13 28 29 28 44 0 34 -16 39 -40 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 205 c0 -3 14 -26 30 -50 17 -24 30 -54 30 -67 1 -27 26 -65 37 -54 15 15 11 65 -6 71 -9 3 -27 26 -41 52 -22 41 -50 68 -50 48z m94 -151 c3 -8 2 -12 -4 -9 -6 3 -10 10 -10 16 0 14 7 11 14 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 71 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3 -10 2 -10 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 35 c21 -16 77 -20 90 -8 4 4 24 6 45 4 22 -1 42 2 46 8 4 8 -26 11 -97 11 -93 -1 -101 -2 -84 -15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrifoodLogoSmall);
export default __webpack_public_path__ + "static/media/trifood-logo-small.b05e04d9d9e3a0b28bcc9e06a606d187.svg";
export { ForwardRef as ReactComponent };